import { companyFilterChange } from 'containers/PartnerOptions/actions'

import {
  CHECKBOX_TOGGLE,
  CLOSE_ALLOW_LIST_MODAL,
  CREATE_INCIDENT,
  CREATE_PRESET_ASYNC,
  FETCH_FILTERS,
  FETCH_LOGS_ENTIRE_COUNT,
  FETCH_MITIGATION_DATA_ASYNC,
  FETCH_PRESETS_ASYNC,
  FETCH_THREAT_LOG_DATA,
  MAX_ENTITY_COUNTER,
  PAGINATE_CHANGE,
  RELEASE_FROM_INCIDENT_SPAM_ASYNC,
  RELEASE_FROM_INVESTIGATION_ASYNC,
  RELEASE_FROM_MS_QUARANTINE_ASYNC,
  RELEASE_FROM_SPAM_ASYNC,
  REMOVE_PRESET_ASYNC,
  RESET_ALL_FILTERS,
  RESET_ARRIVAL_END_DATE,
  RESET_LOG_END_DATE,
  SELECT_ALL,
  SELECT_ALL_RESULTS_TOGGLE,
  SELECT_SAVED_FILTER,
  SET_ALL_FILTERS,
  SET_ARRIVAL_DATE_FILTER,
  SET_DEFAULT_PRESET_ASYNC,
  SET_FILTER,
  SET_FILTERS_FROM_URL,
  SET_LOADER,
  SET_LOG_DATE_FILTER,
  SET_TAGS_PAGE,
  SET_TAGS_SEARCH,
  SET_UNCHANGEABLE,
  THREAT_LOG_BACKGROUND_REFRESH,
  UNSELECT_ALL,
  UPDATE_PRESET_ASYNC,
} from './constants'
import { createFiltersFromUrl, initialFilters, isFiltersEqual } from './utils'

export { companyFilterChange } from 'containers/PartnerOptions/actions'

export const fetchFilters = () => ({
  type: FETCH_FILTERS.INITIATE,
})
export const fetchFiltersSuccess = (data) => ({
  type: FETCH_FILTERS.SUCCESS,
  payload: data,
})
export const fetchFiltersError = (error) => ({
  type: FETCH_FILTERS.ERROR,
  payload: error,
})

export const fetchThreatLogData = (page) => ({
  type: FETCH_THREAT_LOG_DATA.INITIATE,
  payload: { page },
})

/** Re-reads the current page without clearing rows, selection, or the loader. */
export const refreshThreatLogInBackground = () => ({
  type: THREAT_LOG_BACKGROUND_REFRESH,
})
export const fetchThreatLogDataSuccess = (response) => ({
  type: FETCH_THREAT_LOG_DATA.SUCCESS,
  payload: {
    data: response.data ?? [],
    total: response.total_hits?.value ?? 0,
    greaterThenMaxTotal:
      response.total_hits?.relation === 'gte' && response.total_hits?.value === MAX_ENTITY_COUNTER,
  },
})
export const fetchThreatLogDataError = (error) => ({
  type: FETCH_THREAT_LOG_DATA.ERROR,
  payload: error,
})
export const fetchThreatLogDataCancel = (reason) => ({
  type: FETCH_THREAT_LOG_DATA.CANCEL,
  reason,
})

export const setFilter = (filter, value) => ({
  type: SET_FILTER,
  payload: { filter, value },
})
export const setLogDateFilter = (date, options = { preventApiCall: false }) => ({
  type: SET_LOG_DATE_FILTER,
  payload: { date, preventApiCall: options.preventApiCall },
})
export const setArrivalDateFilter = (date, options = { preventApiCall: false }) => ({
  type: SET_ARRIVAL_DATE_FILTER,
  payload: { date, preventApiCall: options.preventApiCall },
})

export const setAllFilters = (filters) => ({ type: SET_ALL_FILTERS, payload: filters })
export const resetAllFilters = () => ({ type: RESET_ALL_FILTERS })

export const paginateChange = (page) => ({ type: PAGINATE_CHANGE, payload: page })
export const resetLogEndDate = () => ({ type: RESET_LOG_END_DATE })
export const resetArrivalEndDate = () => ({ type: RESET_ARRIVAL_END_DATE })

export const createIncident = (emailEntity) => ({
  type: CREATE_INCIDENT.INITIATE,
  payload: emailEntity,
})
export const createIncidentError = (error, email) => ({
  type: CREATE_INCIDENT.ERROR,
  payload: { error, email },
})
export const createIncidentSuccess = (eid, incidentId) => ({
  type: CREATE_INCIDENT.SUCCESS,
  payload: {
    eid,
    incidentId,
  },
})
const setFiltersFromUrl = (filters) => ({ type: SET_FILTERS_FROM_URL, payload: filters })

export const fetchLogsEntireCount = () => ({ type: FETCH_LOGS_ENTIRE_COUNT.INITIATE })
export const fetchLogsEntireCountSuccess = ({ response }) => ({
  type: FETCH_LOGS_ENTIRE_COUNT.SUCCESS,
  payload: { response },
})
export const fetchLogsEntireCountError = (error) => ({
  type: FETCH_LOGS_ENTIRE_COUNT.ERROR,
  payload: error,
})
export const fetchLogsEntireCountCancel = () => ({ type: FETCH_LOGS_ENTIRE_COUNT.CANCEL })

export const fetchMitigationData = (record) => ({
  type: FETCH_MITIGATION_DATA_ASYNC.INITIATE,
  payload: record,
})
export const fetchMitigationDataSuccess = (data) => ({
  type: FETCH_MITIGATION_DATA_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchMitigationDataError = (error) => ({
  type: FETCH_MITIGATION_DATA_ASYNC.ERROR,
  error,
})
export const fetchMitigationDataCancel = () => ({ type: FETCH_MITIGATION_DATA_ASYNC.CANCEL })

export const setDefaultPreset = (presetId) => ({
  type: SET_DEFAULT_PRESET_ASYNC.INITIATE,
  payload: { presetId, isChosenDefault: true },
})
export const removePreset = (presetId) => ({
  type: REMOVE_PRESET_ASYNC.INITIATE,
  payload: { presetId },
})
export const removePresetError = (error) => ({
  type: REMOVE_PRESET_ASYNC.ERROR,
  payload: error,
})
export const removePresetSuccess = () => ({
  type: REMOVE_PRESET_ASYNC.SUCCESS,
})

export const createPreset = (presetName, filters) => ({
  type: CREATE_PRESET_ASYNC.INITIATE,
  payload: { presetName, filters },
})
export const createPresetSuccess = (response) => ({
  type: CREATE_PRESET_ASYNC.SUCCESS,
  payload: { response },
})

export const updatePreset = (presetId, updates) => ({
  type: UPDATE_PRESET_ASYNC.INITIATE,
  payload: { ...updates, presetId },
})

export const updatePresetSuccess = () => ({
  type: UPDATE_PRESET_ASYNC.SUCCESS,
})

export const fetchPresets = (skipApplyFilters) => ({
  type: FETCH_PRESETS_ASYNC.INITIATE,
  payload: { skipApplyFilters },
})

export const fetchPresetsError = (error) => ({
  type: FETCH_PRESETS_ASYNC.ERROR,
  payload: error,
})
export const fetchPresetsCancel = () => ({
  type: FETCH_PRESETS_ASYNC.CANCEL,
})

export const preparePayload = (payload) => {
  // presets response may be an empty object (e.g. the mock fallback response)
  const presets = Array.isArray(payload) ? payload : []
  const savedFilters = presets.reduce((acc, preset) => {
    acc[preset.presetId] = preset
    const filters = acc[preset.presetId].filters
    const presetFilters = preset.filters
    filters.logDateFilter = Array.isArray(presetFilters.logDateFilter)
      ? presetFilters.logDateFilter
      : presetFilters.logDateFilter === null
        ? null
        : +presetFilters.logDateFilter
    // dirty way to avoid migration on be side
    filters.emailDateFilter = Array.isArray(presetFilters.emailDateFilter)
      ? !presetFilters.emailDateFilter[0].endsWith('Z')
        ? [`${presetFilters.emailDateFilter[0]}Z`, `${presetFilters.emailDateFilter[1]}Z`]
        : presetFilters.emailDateFilter
      : +preset.filters.emailDateFilter
    Object.keys(filters).forEach((filter) => {
      if (typeof filters[filter] === 'boolean') {
        filters[filter] = [filters[filter]]
      }
    })
    return acc
  }, {})
  const savedFiltersOrder = presets.map((preset) => preset.presetId)
  const defaultFilter =
    presets.find((preset) => preset.isChosenDefault) || presets.find((preset) => preset.isSystem)
  const fromURL = createFiltersFromUrl()
  return {
    savedFilters,
    savedFiltersOrder,
    defaultFilter,
    filterFromUrl: fromURL ? (isFiltersEqual(fromURL, initialFilters) ? null : fromURL) : null,
  }
}

export const fetchPresetsSuccess = (payload) => ({
  type: FETCH_PRESETS_ASYNC.SUCCESS,
  payload,
})

export const selectSavedFilter = (presetId) => ({
  type: SELECT_SAVED_FILTER,
  payload: { presetId },
})

export const releaseMSQuarantineEmail = (messageId, newId, recipientAddress, index) => ({
  type: RELEASE_FROM_MS_QUARANTINE_ASYNC.INITIATE,
  payload: { messageId, newId, recipientAddress, index },
})

export const releaseFromInvestigation = (index, id) => ({
  type: RELEASE_FROM_INVESTIGATION_ASYNC.INITIATE,
  payload: { index, id },
})

export const releaseFromInvestigationSuccess = () => ({
  type: RELEASE_FROM_INVESTIGATION_ASYNC.SUCCESS,
})

export const releaseFromInvestigationError = (error) => ({
  type: RELEASE_FROM_INVESTIGATION_ASYNC.ERROR,
  payload: { error },
})

export const releaseFromIncidentSpamSuccess = () => ({
  type: RELEASE_FROM_INCIDENT_SPAM_ASYNC.SUCCESS,
})

export const releaseFromIncidentSpamError = (error) => ({
  type: RELEASE_FROM_INCIDENT_SPAM_ASYNC.ERROR,
  payload: { error },
})

export const setUnchangeable = (payload) => ({
  type: SET_UNCHANGEABLE,
  payload,
})

export const setLoader = (payload) => ({
  type: SET_LOADER,
  payload,
})

export const closeAllowListModal = () => ({
  type: CLOSE_ALLOW_LIST_MODAL,
})

export const checkboxOnChange = (id) => ({ type: CHECKBOX_TOGGLE, payload: { id } })
export const selectAll = () => ({ type: SELECT_ALL })
export const unselectAll = () => ({ type: UNSELECT_ALL })
export const toggleSelectAllResults = () => ({ type: SELECT_ALL_RESULTS_TOGGLE })

export const releaseFromSpam = () => ({
  type: RELEASE_FROM_SPAM_ASYNC.INITIATE,
})
export const releaseFromSpamSuccess = (data) => ({
  type: RELEASE_FROM_SPAM_ASYNC.SUCCESS,
  payload: data,
})
export const releaseFromSpamError = (error) => ({
  type: RELEASE_FROM_SPAM_ASYNC.ERROR,
  payload: error,
})

export const setTagsPage = (page) => ({
  type: SET_TAGS_PAGE,
  payload: { page },
})

export const setTagsSearch = (search) => ({
  type: SET_TAGS_SEARCH,
  payload: { search },
})

export default {
  resetLogEndDate,
  resetArrivalEndDate,
  companyFilterChange,
  fetchThreatLogData,
  fetchThreatLogDataCancel,
  paginateChange,
  fetchFilters,
  setFilter,
  setLogDateFilter,
  setArrivalDateFilter,
  setAllFilters,
  resetAllFilters,
  createIncident,
  setFiltersFromUrl,
  fetchLogsEntireCount,
  fetchLogsEntireCountSuccess,
  fetchLogsEntireCountError,
  fetchMitigationData,
  fetchMitigationDataCancel,
  fetchPresets,
  releaseMSQuarantineEmail,
  releaseFromInvestigation,
  fetchPresetsCancel,
  closeAllowListModal,
  checkboxOnChange,
  selectAll,
  unselectAll,
  toggleSelectAllResults,
  releaseFromSpam,
  setTagsPage,
  setTagsSearch,
}
